var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "25px",
    viewBox: "0 0 22 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7BEF20CD-FA8E-47DE-9E7C-5B2A13FACDBD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager-|-Assign-Audits-All",
    transform: "translate(-1625.000000, -27.000000)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bell2",
    transform: "translate(1611.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8,30.1 C31.7,29 31,27.6 31,26 L31,23.1 C31,20.4 29.2,18 26.7,17.2 C27.2,16.2 27.3,15.8 27.3,15.5 C27.3,14.1 26.2,13 24.9,13 C23.6,13 22.5,14.1 22.5,15.4 C22.5,15.8 22.7,16.4 23.1,17.1 C20.6,17.9 18.8,20.2 18.8,23 L18.8,25.9 C18.8,27.5 18.1,28.9 17,30 C15.9,30 15,30.9 15,32 C15,33.1 15.9,34 17,34 L21.7,34 C21.7,35.8 23.2,37.2 24.9,37.2 C26.7,37.2 28.1,35.7 28.1,34 L32.8,34 C33.9,34 34.8,33.1 34.8,32 C34.9,30.9 34,30.1 32.8,30.1 L32.8,30.1 Z M24.9,14 C25.7,14 26.3,14.7 26.3,15.4 C26.3,15.5 26.2,15.9 25.7,16.9 C25.6,16.9 24.5,16.7 24,16.9 C23.5,15.9 23.4,15.6 23.4,15.4 C23.4,14.7 24.1,14 24.9,14 Z M19.7,26 L19.7,23.1 C19.7,20.3 22,17.9 24.9,17.9 C27.7,17.9 30.1,20.2 30.1,23.1 L30.1,26 C30.1,27.5 30.6,28.9 31.5,30.1 L18.3,30.1 C19.2,28.9 19.7,27.4 19.7,26 L19.7,26 Z M27.1,34.1 C27.1,35.3 26.1,36.3 24.9,36.3 C23.7,36.3 22.7,35.3 22.7,34.1 L27.1,34.1 Z M32.8,33.1 L16.9,33.1 C16.3,33.1 15.9,32.6 15.9,32.1 C15.9,31.5 16.4,31.1 16.9,31.1 L32.8,31.1 C33.4,31.1 33.8,31.6 33.8,32.1 C33.9,32.7 33.4,33.1 32.8,33.1 L32.8,33.1 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.d6845a2b89b43e5f873072533575cbb7.svg";
export { ForwardRef as ReactComponent };